import I18n from 'i18n-js'
import { capitalize } from '../helpers'
import ca from '../translations/ca.json'
import es from '../translations/es.json'
import en from '../translations/en.json'
import it from '../translations/it.json'
import fr from '../translations/fr.json'

I18n.fallbacks = true
I18n.translations = {
  ca,
  en,
  es,
  it,
  fr
}

export type Language = keyof typeof I18n

class LiteralsService {
  private language = this.getDefaultLanguageForTranslations()

  constructor() {}

  public get(key: string, capitalized = false): string {
    const res = this.getKey(key)
    return capitalized ? capitalize(res) : res
  }

  public getOrDefault(key: string | undefined | null, fallbackKey: string, capitalized: boolean = false): string {
    if (key && I18n.translations[this.language] && (I18n.translations[this.language] as any)[key]) {
      return this.get(key, capitalized)
    }
    if (key && I18n.translations[this.getDefaultLanguageForTranslations()] && (I18n.translations[this.getDefaultLanguageForTranslations()] as any)[key]) {
      return this.get(key, capitalized)
    }
    return this.get(fallbackKey, capitalized)
  }

  public isLanguageActive(language: string): boolean {
    return this.language === language
  }

  public setLanguage(language: string): void {
    this.language = language
  }

  public getLanguage(): string {
    return this.language
  }

  public getDefaultLanguageForTranslations(): string {
    let language = 'en'
    Object.keys(I18n.translations).forEach((lang) => {
      if (lang === navigator.language.split('-')[0]) language = lang
    })
    return language
  }

  private getKey(key: string): string {
    return I18n.t(key, {locale: this.language}) || key
  }
}

export default new LiteralsService()
